var swiper = new Swiper(".comments-swiper", {
  slidesPerView: 1.05,
  spaceBetween: 30,
  loop: true,
  breakpoints: {
    768: {
      slidesPerView: 2.05,
    },
    1024: {
      slidesPerView: 3.05,
    },
    1440: {
      slidesPerView: 5.05,
    },
  },
  navigation: {
    nextEl: ".swiper-button-next.comments-swiper-button",
    prevEl: ".swiper-button-prev.comments-swiper-button",
  },
});

let currentIdx = 0

const slides = document.querySelectorAll(".comments-swiper .swiper-slide")
slides.forEach((item,i) => {
  item.addEventListener("click",(e) => {
    const {commenterName,comment,date,img_1,img_2,img_3} = comments[i]
    openModal(commenterName,img_1,img_2,img_3,comment,date)
    currentIdx = i
  } )
})

const modal = document.querySelector("div[data-role='comments-modal']");
const mainImage = modal.querySelector("img[data-role='main-img']");
const thumbnails = modal.querySelectorAll(
  ".comments-modal_img_container .thumbnails img"
);
const commentName = modal.querySelector(".comment-name");
const comment = modal.querySelector(".comment");
const modalDate = modal.querySelector(".comments-comment_info .date")

thumbnails.forEach((item) => {
  item.addEventListener("click", (e) => {
    mainImage.src = item.src;
  });
});

function openModal(name, img_1, img_2, img_3, content,date) {
  fillModalContent(name, img_1, img_2, img_3, content,date);
  modal.classList.remove("hidden");
  setTimeout(() => {
    modal.classList.add("visible");
  }, 0);
}

function closeModal() {
  modal.classList.remove("visible");
  setTimeout(() => {
    modal.classList.add("hidden");
  }, 200);
}

function fillModalContent(name, img_1, img_2, img_3, content,date) {
  mainImage.src = img_1;
  thumbnails[0].src = img_1;
  thumbnails[1].src = img_2;
  thumbnails[2].src = img_3;
  commentName.innerHTML = name;
  comment.innerHTML = content;
  modalDate.innerHTML = date
}

function handleModalClick(e) {
  const target = e.target;
  const shouldCloseModal = target.dataset.shouldCloseModal !== undefined;
  if (shouldCloseModal) return closeModal();
}


const modalNavs = document.querySelectorAll(".comments-modal_nav");
for (const item of modalNavs) {
  item.addEventListener("click", async () => {
    const isTargetNext = item.classList.contains("next");
    if (isTargetNext) {
      const {item:nextElement,idx} = getNextItem(comments,currentIdx);
      currentIdx = idx;
      fillModalContent(
        nextElement.commenterName,
        nextElement.img_1,
        nextElement.img_2,
        nextElement.img_3,
        nextElement.comment,
        nextElement.date
      );
      
      const elementToPreloaded = getNextItem(comments,idx)
      preloadThumbnails(elementToPreloaded.item)
      
      swiper.slideNext();
    } else {
      const {item:prevElement,idx} = getPreviousItem(comments,currentIdx)
      currentIdx = idx;
      fillModalContent(
        prevElement.commenterName,
        prevElement.img_1,
        prevElement.img_2,
        prevElement.img_3,
        prevElement.comment,
        prevElement.date
      );

      const elementToPreloaded = getPreviousItem(comments,idx)
      preloadThumbnails(elementToPreloaded.item)
      
      swiper.slidePrev();
    }
  });
}

function getNextItem(arr,currentIndex){
    if(currentIndex === arr.length-1) return {item:arr[0],idx:0}
    return {item:arr[currentIndex+1],idx:currentIndex+1}
}

function getPreviousItem(arr,currentIndex) {
    if(currentIndex === 0) return {item:arr[arr.length-1],idx:arr.length-1}
    return {item:arr[currentIndex-1],idx:currentIdx-1}
}

function preloadThumbnails(data){
      const {img_1,img_2,img_3} = data
      const imageArray = [img_1,img_2,img_3]    
      for (let i = 0; i < 3; i++) {
          const img = new Image()
          img.src = imageArray[i];
      }
}
